export const HomePage = '/Home';
export const BillingSummaryReportPage = '/BillingSummaryReport';
export const BillingDetailPage = '/BillingDetail';
export const SpecialBillingPage = '/SpecialofBilling';
